<template>
  <div class="input-group">
    <input
      :id="id"
      v-model="model"
      class="checkbox option-input"
      :disabled="disabled"
      type="checkbox"
    />

    <label class="d-flex m-0" :for="id">
      <span
        class="mt-1 bg-white pr-3"
        :class="{ 'bg-secondary-10 border-color--primary-5': hasError }"
      >
        <em v-if="model" class="ic-check" />
      </span>
      <div>
        <label
          v-if="headline"
          class="color-black font-weight-bold mb-n1"
          :for="id"
        >
          {{ headline }}
        </label>
        {{ text }}
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: 'CustomCheckbox',
  props: {
    text: String,
    value: {
      type: Boolean,
      default: () => null,
    },
    disabled: {
      type: Boolean,
      default: () => null,
    },
    hasError: {
      type: [Boolean, String],
      default: () => null,
    },
    headline: {
      type: String,
      default: () => '',
    },
  },
  data() {
    return {
      model: this.value,
      id: Math.random().toString(36),
    };
  },
  watch: {
    model(val) {
      this.$emit('input', val);
    },
    value(val) {
      this.model = val;
    },
  },
};
</script>

<style scoped>
.input-group .option-input {
  display: none;
}
.input-group .option-input + label span {
  display: inline-block;
  width: 20px;
  height: 20px;
  margin: -2px 10px 0 0;
  vertical-align: middle;
  border: 1px solid #e2e2e2;
  border-radius: 4px;
  cursor: pointer;
}
.input-group .option-input:checked + label span .ic-check {
  background: url('./icon-check-solid.svg');
  background-size: cover;
  display: flex;
  width: 18px;
  height: 14px;
  margin: 2px auto;
}
</style>
